import React from 'react';

interface AlertDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  type?: 'info' | 'warning' | 'error' | 'success';
  onConfirm: () => void;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Aceptar',
  type = 'info',
  onConfirm
}) => {
  if (!isOpen) return null;

  const typeStyles = {
    info: {
      bg: 'bg-blue-50 dark:bg-blue-900/20',
      border: 'border-blue-200 dark:border-blue-800',
      icon: 'info',
      iconColor: 'text-blue-500',
      button: 'bg-blue-500 hover:bg-blue-600'
    },
    warning: {
      bg: 'bg-yellow-50 dark:bg-yellow-900/20',
      border: 'border-yellow-200 dark:border-yellow-800',
      icon: 'warning',
      iconColor: 'text-yellow-500',
      button: 'bg-yellow-500 hover:bg-yellow-600'
    },
    error: {
      bg: 'bg-red-50 dark:bg-red-900/20',
      border: 'border-red-200 dark:border-red-800',
      icon: 'error',
      iconColor: 'text-red-500',
      button: 'bg-red-500 hover:bg-red-600'
    },
    success: {
      bg: 'bg-green-50 dark:bg-green-900/20',
      border: 'border-green-200 dark:border-green-800',
      icon: 'check_circle',
      iconColor: 'text-green-500',
      button: 'bg-green-500 hover:bg-green-600'
    }
  };

  const styles = typeStyles[type];

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-white dark:bg-surface-dark rounded-2xl max-w-md w-full shadow-2xl animate-slide-up">
        <div className={`${styles.bg} p-6 rounded-t-2xl border-b ${styles.border}`}>
          <div className="flex items-center gap-3">
            <span className={`material-symbols-outlined text-2xl ${styles.iconColor}`}>
              {styles.icon}
            </span>
            <h3 className="text-lg font-bold text-text-main dark:text-white">{title}</h3>
          </div>
        </div>

        <div className="p-6">
          <p className="text-text-main dark:text-white leading-relaxed">{message}</p>
        </div>

        <div className="flex justify-end p-6 pt-0">
          <button
            onClick={onConfirm}
            className={`px-6 py-3 text-white font-semibold rounded-xl transition-colors ${styles.button}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertDialog;
